import { Modal } from "bootstrap";

import {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useRef,
    useState,
} from "react";

// import * as b2cleadService from "../../Services/b2cleadService";
import * as b2bleadService from "../../Services/b2bleadService";

const B2BLeadLifeCycleModal = forwardRef(
    (props, ref) => {

        // =====================================
        // REFS
        // =====================================

        const modalRef = useRef(null);

        const bsModal = useRef(null);

        // =====================================
        // STATES
        // =====================================

        const [loading, setLoading] =
            useState(false);

        const [statusHistory, setStatusHistory] =
            useState([]);

        const [selectedLeadId, setSelectedLeadId] =
            useState(null);


        useEffect(() => {

            if (modalRef.current) {

                bsModal.current =
                    new Modal(
                        modalRef.current,
                        {
                            backdrop: true,
                            keyboard: true,
                        }
                    );

            }

            return () => {

                bsModal.current?.dispose();

            };

        }, []);

        // =====================================
        // HANDLE CLOSE
        // =====================================

        const handleClose = () => {

            bsModal.current?.hide();

            document.body.classList.remove(
                "modal-open"
            );

            document.body.style.overflow = "";

            document.body.style.paddingRight =
                "";

            const backdrops =
                document.querySelectorAll(
                    ".modal-backdrop"
                );

            backdrops.forEach((el) =>
                el.remove()
            );

        };

        // =====================================
        // GET STATUS HISTORY
        // =====================================

        const getLeadStatusHistory =
            (leadId) => {

                if (!leadId)
                    return;

                setLoading(true);

                b2bleadService
                    .getLeadStatusHistory(
                        leadId
                    )

                    .then((res) => {

                        if (
                            res?.data
                                ?.status ===
                            "success"
                        ) {

                            setStatusHistory(
                                res?.data
                                    ?.data || []
                            );

                        } else {

                            setStatusHistory(
                                []
                            );

                        }

                    })

                    .catch((error) => {

                        console.log(
                            "Lead history error",
                            error
                        );

                        setStatusHistory(
                            []
                        );

                    })

                    .finally(() => {

                        setLoading(false);

                    });

            };

        // =====================================
        // OPEN / CLOSE
        // =====================================

        useImperativeHandle(
            ref,
            () => ({

                toggle(leadId) {

                    setSelectedLeadId(
                        leadId
                    );

                    getLeadStatusHistory(
                        leadId
                    );

                    bsModal.current?.show();

                },

                close() {

                    handleClose();

                },

            })
        );

        return (

            <div
                className="modal fade"
                ref={modalRef}
                tabIndex="-1"
                aria-hidden="true"
                style={{
                    background:
                        "rgba(15,23,42,0.55)",

                    backdropFilter:
                        "blur(5px)",
                }}
            >

                <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">

                    <div
                        className="modal-content border-0 overflow-hidden"
                        style={{
                            borderRadius:
                                "24px",

                            boxShadow:
                                "0 20px 60px rgba(0,0,0,0.15)",
                        }}
                    >

                        {/* ===================================== */}
                        {/* HEADER */}
                        {/* ===================================== */}

                        <div
                            className="modal-header border-0 text-white"
                            style={{
                                background:
                                    "rgb(94, 44, 158)",
                            }}
                        >

                            <div >

                                {/* <h4 className="fw-bold mb-1">

                                    Lead Life Cycle

                                </h4> */}

                                <p className="mb-0 small opacity-75">

                                    Lead Life Cycle

                                </p>

                            </div>

                            <button
                                type="button"
                                className="btn btn-light rounded-circle position-absolute"
                                style={{
                                    top: "10px",
                                    right: "18px",
                                    width: "38px",
                                    height: "38px",
                                }}
                                onClick={
                                    handleClose
                                }
                            >

                                <i className="fa fa-times"></i>

                            </button>

                        </div>

                        {/* ===================================== */}
                        {/* BODY */}
                        {/* ===================================== */}

                        <div
                            className="modal-body p-4"
                            style={{
                                background:
                                    "#f8fafc",
                            }}
                        >

                            {/* TOP */}

                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4">

                                <div>

                                    <h5 className="fw-bold text-dark mb-1">

                                        Status Timeline

                                    </h5>

                                    <p className="text-muted mb-0">

                                        Lead ID :
                                        {" "}

                                        <span className="fw-semibold text-dark">

                                            FS
                                            {
                                                selectedLeadId
                                            }

                                        </span>

                                    </p>

                                </div>

                                {/* <span className="badge bg-primary rounded-pill px-3 py-2 fs-6">

                                    Total Records :
                                    {" "}

                                    {
                                        statusHistory?.length
                                    }

                                </span> */}

                            </div>

                            {/* TABLE */}

                            <div
                                className="table-responsive border rounded-4 bg-white"
                                style={{
                                    maxHeight:
                                        "500px",

                                    overflowY:
                                        "auto",
                                }}
                            >

                                <table className="table align-middle mb-0">

                                    {/* TABLE HEADER */}

                                    <thead
                                        style={{
                                            background:
                                                "#eff6ff",

                                            position:
                                                "sticky",

                                            top: 0,

                                            zIndex: 2,
                                        }}
                                    >

                                        <tr>

                                            <th className="text-center py-3 border-0 fw-semibold">
                                                Date
                                            </th>

                                            <th className="text-center py-3 border-0 fw-semibold">
                                                Status
                                            </th>

                                            <th className="text-center py-3 border-0 fw-semibold">
                                                Duration
                                            </th>

                                        </tr>

                                    </thead>

                                    {/* TABLE BODY */}

                                    <tbody>

                                        {loading ? (

                                            <tr>

                                                <td
                                                    colSpan={
                                                        3
                                                    }
                                                    className="text-center py-5"
                                                >

                                                    <div className="spinner-border text-primary"></div>

                                                </td>

                                            </tr>

                                        ) : statusHistory?.length >
                                            0 ? (

                                            statusHistory.map(
                                                (
                                                    item,
                                                    index
                                                ) => (

                                                    <tr
                                                        key={
                                                            item?.id ||
                                                            index
                                                        }
                                                    >

                                                        {/* DATE */}

                                                        <td className="text-center py-3">

                                                            <div className="fw-semibold text-dark">

                                                                {item?.createdAt
                                                                    ? new Date(
                                                                        item.createdAt
                                                                    ).toLocaleDateString(
                                                                        "en-GB",
                                                                        {
                                                                            day: "2-digit",
                                                                            month: "short",
                                                                            year: "numeric",
                                                                        }
                                                                    )
                                                                    : "--"}

                                                            </div>

                                                            <small className="text-muted">

                                                                {item?.createdAt
                                                                    ? new Date(
                                                                        item.createdAt
                                                                    ).toLocaleTimeString(
                                                                        "en-US",
                                                                        {
                                                                            hour: "2-digit",
                                                                            minute: "2-digit",
                                                                        }
                                                                    )
                                                                    : "--"}

                                                            </small>

                                                        </td>

                                                        {/* STATUS */}

                                                        <td className="text-center py-3">

                                                            <span className="badge bg-primary-subtle text-primary rounded-pill px-3 py-2">

                                                                {
                                                                    item?.b2bStatus ||
                                                                    "--"
                                                                }

                                                            </span>

                                                        </td>

                                                        {/* DURATION */}

                                                        <td className="text-center fw-semibold py-3">

                                                            {
                                                                item?.duration ||
                                                                "--"
                                                            }

                                                        </td>

                                                    </tr>

                                                )
                                            )

                                        ) : (

                                            <tr>

                                                <td
                                                    colSpan={
                                                        3
                                                    }
                                                    className="text-center py-5 text-muted"
                                                >

                                                    No Status History Found

                                                </td>

                                            </tr>

                                        )}

                                    </tbody>

                                </table>

                            </div>

                        </div>



                        <div className="modal-footer border-0 bg-white px-4 py-3">

                            <button
                                type="button"
                                className="btn btn-sm btn-light border rounded-pill px-4 fw-semibold"
                                onClick={
                                    handleClose
                                }
                            >

                                Close

                            </button>

                        </div>

                    </div>

                </div>

            </div>

        );

    }
);

export default B2BLeadLifeCycleModal;